<script setup lang="ts">
import { computed } from 'vue'

const emit = defineEmits<{
  (event: 'open-review'): void
}>()

const props = defineProps<{
  thumbnailUrl?: string
  authorName?: string
  duration?: number
  date?: string
}>()

const durationAsStr = computed(() => {
  if (!props.duration) return '0:00'

  const mins = Math.floor(props.duration / 60)
  const secs = props.duration % 60
  return `${mins}:${secs.toString().padStart(2, '0')}`
})
</script>

<template>
  <article class="public-review-video">
    <a
      target="_blank"
      class="public-review-video__thumbnail"
      :style="{ backgroundImage: `url(${thumbnailUrl})` }"
      aria-label="Посмотреть отзыв"
      @click="emit('open-review')"
    >
      <!-- TODO: how do we get duration data? -->
      <div v-if="false" class="public-review-video__thumbnail-metadata">
        <v-icon size="24" class="blue-text mr-half">mdi-play</v-icon>
        {{ durationAsStr }}
      </div>

      <div class="public-review-video__thumbnail-hover" aria-hidden>
        <v-icon size="40">mdi-play</v-icon>
        <span class="ml-1">Посмотреть отзыв</span>
      </div>
    </a>

    <div class="public-review-video__info">
      <h3 class="text-body-bold" v-text="authorName" />

      <p class="public-review-video__body my-1"><slot /></p>

      <span class="public-review-video__date" v-text="date" />
    </div>
  </article>
</template>

<style lang="scss">
.public-review-video {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 200px 200px;
  grid-template-rows: 264px;

  width: 400px;
  height: 264px;
  box-shadow: 0 1px 4px 0px #3a465d4b;
  border-radius: 16px;

  & > * {
    margin: 0;
  }

  &:last-child {
    margin-right: 48px;
  }

  &__thumbnail {
    background-color: $gray;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;

    border-radius: 16px;
    position: relative;
  }

  &__thumbnail-metadata {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;

    padding: 0 8px 0 4px;
    border-radius: 4px;
    background: white;

    position: absolute;
    top: 10px;
    right: 10px;

    display: flex;
  }

  &__thumbnail:hover > &__thumbnail-hover {
    opacity: 1;
  }

  &__thumbnail-hover {
    background: rgba($black, 0.7);

    opacity: 0;
    transition: opacity 0.1s ease;

    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    color: white;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;

    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__info {
    padding: 16px;
    display: flex;
    flex-direction: column;
  }

  &__body {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;

    word-wrap: break-word;
    overflow-wrap: anywhere;
    overflow: hidden;
    text-overflow: ellipsis;

    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 7;

    @include mobile {
      -webkit-line-clamp: 6;
      height: 130px;
    }
  }

  &__date {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;

    color: $darkGray;
  }
}
</style>
